import { Box, Flex } from '@chakra-ui/react'
import { CardMetrics } from 'components/atoms/CardMetrics'

export type Option = {
    value: number
    label: string
}

interface Props {
    options: Option[]
    isLoading?: boolean
}

export function ListCardMetrics({ options, isLoading = true }: Props) {
    const placeholderOptions = Array(3).fill({ value: 0, label: '' })

    return (
        <Box>
            <Flex
                direction={{ base: 'column', md: 'row' }}
                gap="20px"
                marginBottom="32px"
            >
                {isLoading
                    ? placeholderOptions.map((_, index) => (
                          <CardMetrics
                              key={index}
                              value={0}
                              label=""
                              isLoading={true}
                          />
                      ))
                    : options.map((option, index) => (
                          <CardMetrics
                              key={index}
                              value={option.value}
                              label={option.label}
                              isLoading={false}
                          />
                      ))}
            </Flex>
        </Box>
    )
}
